// src/components/FullAbout/FAQ/FAQ.jsx
import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { BsChevronDown, BsChevronUp } from 'react-icons/bs';
import Navbar from '../../Navbar/navbar';
import Footer from '../../Footer/Footer';
import './FAQ.css';

// Import Image
import faqImg from '../../../assets/Faq.jpeg';

const FAQ = () => {
  // Scroll top on mount
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const faqData = [
    {
      id: 1,
      question: "What industries do you serve?",
      answer: "We primarily serve the automotive industry, supporting OEMs and Tier-1 suppliers with precision stamped components, sub-assemblies, and tooling solutions."
    },
    {
      id: 2,
      question: "What manufacturing capabilities do you offer?",
      answer: "Our core capabilities include precision metal stamping, in-house tool design & development, progressive and transfer die manufacturing, robotic welding, injection moulding, CNC machining, and quality inspection systems."
    },
    {
      id: 3,
      question: "Do you have in-house tool room facilities?",
      answer: "Yes. Our fully integrated in-house tool room enables tool design, development, maintenance, and engineering modifications, ensuring faster lead times and better process control."
    },
    {
      id: 4,
      question: "What quality certifications do you hold?",
      answer: "Dynamic Stamping is certified to ISO 9001:2015 and IATF 16949:2016 standards, ensuring compliance with global automotive quality requirements."
    },
    {
      id: 5,
      question: "Do you support new product development (NPD)?",
      answer: "Yes. We support OEM and Tier-1 customers with engineering assistance, tooling development, process validation, and scalable production support for new programs."
    },
    {
      id: 6,
      question: "What production volumes can you handle?",
      answer: "Our high-capacity stamping presses and automated systems enable us to handle both medium and high-volume automotive production with consistent quality and repeatability."
    }
  ];

  const [openIndices, setOpenIndices] = useState(faqData.map((_, index) => index));

  const toggleAccordion = (index) => {
    setOpenIndices(prev =>
      prev.includes(index)
        ? prev.filter(i => i !== index)
        : [...prev, index]
    );
  };

  return (
    <div className="faq-page-wrapper">
      <Navbar />

      <section className="about-hero-section">
        <Container>
          <Row>
            <Col lg={12}>
              <div className="about-hero-content">
                {/* Main Title: About (Regular) Us (Bold) */}
                <h1 className="about-hero-title">
                  <span>Frequently Asked Questions</span>
                </h1>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <div className="container py-5 mt-5">
        <Row>

          {/* LEFT COLUMN: Header + Description + Image */}
          <Col lg={5} md={12} className="mb-5 mb-lg-0 pe-lg-5" style={{ alignContent: "start" }}>
            <div className="faq-left-content">
              <h2 className="faq-heading mb-3">
                Our Frequently Asked <strong>Questions</strong>
              </h2>
              <p className="text-muted mb-4">
                Key information about our manufacturing capabilities, quality systems, and OEM partnerships.
              </p>
              <div className="faq-img-wrapper rounded-4 overflow-hidden shadow-lg">
                <img src={faqImg} alt="Factory Worker" className="img-fluid w-100 object-fit-cover" style={{ height: '300px' }} />
              </div>
            </div>
          </Col>

          {/* RIGHT COLUMN: Accordion List */}
          <Col lg={7} md={12}>
            <div className="faq-list">
              {faqData.map((item, index) => (
                <div
                  key={item.id}
                  className={`faq-item ${openIndices.includes(index) ? 'active' : ''}`}
                  onClick={() => toggleAccordion(index)}
                >
                  <div className="faq-header">
                    <h5 className="faq-question mb-0">{item.question}</h5>
                    <div className="faq-icon-circle">
                      {openIndices.includes(index) ? <BsChevronUp /> : <BsChevronDown />}
                    </div>
                  </div>
                  <div className={`faq-body ${openIndices.includes(index) ? 'show' : ''}`}>
                    <div className="faq-answer-wrapper">
                      <p className="faq-answer text-muted mb-0">{item.answer}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </Col>

        </Row>
      </div>
      <Footer />
    </div>
  );
};

export default FAQ;